import React, { useRef } from "react";
import SVG from "react-inlinesvg";

import iconIconSearch from "../../assets/svg/icon-search.svg";

export const SearchNav = (): React.ReactNode => {
    const searchInputComponent = useRef<HTMLFormElement | null>(null);

    const toggleSearchView = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();

        if (!searchInputComponent.current) {
            return;
        }

        searchInputComponent.current.classList.toggle("hidden");
    };

    // Need link title since content is an image. See #13290
    return (
        <div className="search-nav__content search-nav__content--mobile-menu">
            <div className="search-nav__search">
                <form
                    ref={searchInputComponent}
                    className="search-nav__search-input hidden"
                    action="/search/"
                    method="get"
                >
                    {/* TODO(i18n): Use t tagged template for placeholder: placeholder={t`Search`} */}
                    <input
                        className="search-nav__search-input--text"
                        type="text"
                        name="query"
                        placeholder="Search"
                    />
                </form>
                {/* TODO(i18n): Use t tagged template for aria-label: aria-label={t`Toggle Search Menu`} */}
                <a
                    aria-label="Toggle Search Menu"
                    href="#"
                    onClick={(e) => {
                        toggleSearchView(e);
                    }}
                >
                    <SVG className="search-nav__icon" src={iconIconSearch} />
                </a>
            </div>
        </div>
    );
};
